import React from "react";
import SelectCardBox from "@/Components/Common/SelectCardBox";
import type { PGModule } from "@/common/payments/usePGModules";

interface PGSelectorSectionProps {
  pgModules: PGModule[];
  selectedPG: PGModule | null;
  onSelect: (pg: PGModule) => void;
}

/**
 * PG 선택 카드 + Toss 위젯 컨테이너
 */
export default function PGSelectorSection({ pgModules, selectedPG, onSelect }: PGSelectorSectionProps) {
  return (
    <>
      {pgModules.length > 1 && (
        <div className="max-w-540 w-full mt-2">
          <SelectCardBox
            items={pgModules}
            selectedItems={[selectedPG]}
            onChange={(item: PGModule) => onSelect(item)}
            isMulti={false}
          />
        </div>
      )}
      <div
        className={
          "max-w-540 w-full" +
          (selectedPG && selectedPG.code === "toss" ? " block" : " hidden")
        }
      >
        <div id="payment-method" className="w-full" />
        <div id="agreement" className="w-full" />
      </div>
    </>
  );
}
